module.exports = {
      id: "magazines-usage",
      viewBox: "0 0 25.36 20.288",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#magazines",
      toString: function () {
        return this.url;
      }
    }